import { render, staticRenderFns } from "./RdssProject.vue?vue&type=template&id=12899a5a&scoped=true&"
import script from "./RdssProject.vue?vue&type=script&lang=js&"
export * from "./RdssProject.vue?vue&type=script&lang=js&"
import style0 from "./RdssProject.vue?vue&type=style&index=0&id=12899a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12899a5a",
  null
  
)

export default component.exports